export default "__VITE_ASSET__4d1420cd__"